import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

import { StandardDialog } from '@components/library/dialog';
import { PrimaryButton, TertiaryButton } from '@components/library/button';

import classes from './styles/bulk-download-limit-dialog.module.scss';

interface BulkDownloadLimitDialogProps {
  clearSelected: () => void;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const BulkDownloadLimitDialog: FunctionComponent<BulkDownloadLimitDialogProps> = ({ clearSelected, open, setOpen }) => (
  <StandardDialog
    id="bulk-download-limit-dialog"
    open={open}
    setOpen={setOpen}
    showFooter={false}
    title={bfTranslate('Download Limit Exceeded')}
    titleIcon="bff-attention"
    width={400}
  >
    <div className={classes.content}>
      <p>{bfTranslate('Please select 1,000 or fewer assets to download in bulk.')}</p>
      <div className={classes.buttonGroup}>
        <TertiaryButton
          className={classnames(classes.button, classes.tertiaryButton)}
          onClick={(): void => setOpen(false)}
        >
          {bfTranslate('Close')}
        </TertiaryButton>
        <PrimaryButton
          className={classes.button}
          onClick={(): void => clearSelected()}
        >
          {bfTranslate('Clear Selection')}
        </PrimaryButton>
      </div>
    </div>
  </StandardDialog>
);
